import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  ListFlexiReimbursementClaimsInput,
  ListFlexiReimbursementClaimsResponse,
  ListFlexiReimbursementClaimsVariables,
} from '../types';

const getFlexiReimbursementClaimsListQuery = gql`
  query PayrollListFlexiReimbursementClaims($input: ListFlexiReimbursementClaimsInput!) {
    payrollListFlexiReimbursementClaims(input: $input) {
      code
      success
      message
      claims {
        claim_id
        tenant_id
        merchant_id
        component_id
        assignment_id
        expense_date
        employee_id
        employee_name
        claim_amount
        approved_amount
        claim_description
        claim_evidence_id
        claim_status
        claim_comments
        last_modified_by
        created_at
        updated_at
        component_display_name
        approval_rejection_date
      }
      total_count
    }
  }
`;

export const getFlexiReimbursementClaimsList = (input: ListFlexiReimbursementClaimsInput) => {
  return graphQLApi<ListFlexiReimbursementClaimsResponse, ListFlexiReimbursementClaimsVariables>({
    query: getFlexiReimbursementClaimsListQuery,
    queryVariables: { input },
  });
};
